var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.9499 0.75C11.8463 0.75 15.1498 3.97634 15.1498 7.89054C15.1498 11.8671 11.7925 14.6576 8.69149 16.5551C8.4655 16.6827 8.2099 16.7498 7.9499 16.7498C7.68991 16.7498 7.43431 16.6827 7.20831 16.5551C4.11308 14.6391 0.75 11.8808 0.75 7.89054C0.75 3.97634 4.05351 0.75 7.9499 0.75Z",
    fill: "#FF4444",
    stroke: "#FF4444",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7484 7.94987C10.7484 9.49624 9.49478 10.7498 7.9484 10.7498C6.40202 10.7498 5.14844 9.49624 5.14844 7.94987C5.14844 6.40349 6.40202 5.1499 7.9484 5.1499C9.49478 5.1499 10.7484 6.40349 10.7484 7.94987Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationRed);
export default __webpack_public_path__ + "static/media/locationRed.2806f57cf74b9dc5df7a15b6f04d82eb.svg";
export { ForwardRef as ReactComponent };